

export class Base {
    pCodRetorno: string;
    pMensaje: string;
    pTotalItems:number;
    pcodRetorno:string;
    pmensaje:string;
}
